export default __webpack_public_path__ + "static/media/vhv.b4427c35.png";